import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { HEADER_STATES } from 'src/app/shared/header/header.helper';
import { APP_COLORS } from 'src/global-styles';
import { SneCollaborativeProblemSolvingBase } from '../sne-collaborative-problem-solving.base';

@Component({
  selector: 'ets-cps-sne-intro',
  templateUrl: './cps-sne-intro.component.html',
  styleUrls: ['./cps-sne-intro.component.scss']
})
export class CpsSneIntroComponent extends SneCollaborativeProblemSolvingBase implements OnInit {

  headerState: HEADER_STATES = HEADER_STATES.BACK;

  APP_COLORS = APP_COLORS;
  numberText = '01.';

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  onClick(){
    this.getNextQuestion();
  }

  ngOnInit(): void {
    this.processParams();
  }

}
